import React from 'react';
interface SectionDividerProps {
  from?: string;
  to?: string;
  direction?: 'top' | 'bottom';
  height?: string;
  className?: string;
}
export const SectionDivider: React.FC<SectionDividerProps> = ({
  from = 'from-white',
  to = 'to-gray-50',
  direction = 'bottom',
  height = 'h-24',
  className = ''
}) => {
  const gradientDirection = direction === 'top' ? 'bg-gradient-to-t' : 'bg-gradient-to-b';
  return;
};